var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 119,
    viewBox: "0 0 251 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_12955_22430)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12955_22430",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -67,
    width: 251,
    height: 250
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "__lottie_element_658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M250.5 -67H0.5V183H250.5V-67Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12955_22430)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_12955_22430",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: -17,
    width: 181,
    height: 180
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "__lottie_element_660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.5 -17H215.5V163H35.5V-17Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_12955_22430)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M154.354 26.0811C135.773 26.0811 115.88 26.0811 97.7113 26.0811C88.8913 26.0811 83.7109 30.6242 83.7109 40.1498C83.7109 61.1414 83.7109 117.28 83.7109 117.28H167.648C167.648 117.28 167.648 65.7278 167.648 39.4442C167.648 30.6242 160.704 26.0811 154.354 26.0811Z",
    fill: "#2D2E50"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M153.626 29.8032C148.871 29.8032 103.093 29.8032 98.3754 29.8032C90.3654 29.8032 86.9121 34.4668 86.9121 43.1176C86.9121 62.1814 86.9121 117.01 86.9121 117.01H164.449C164.449 117.01 164.449 66.3466 164.449 42.4768C164.449 34.4668 159.394 29.8032 153.626 29.8032Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M153.628 29.8032C148.873 29.8032 103.095 29.8032 98.3768 29.8032C90.3668 29.8032 86.9727 34.4796 86.9727 43.1176C98.6538 118.835 164.45 117.01 164.45 117.01C164.45 117.01 164.45 66.3466 164.45 42.4768C164.45 34.4668 159.395 29.8032 153.628 29.8032Z",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M51.8828 117.28H199.123",
    stroke: "#2D2E50",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M138.82 37.7826C138.82 39.7695 137.207 41.3826 135.22 41.3826H115.78C113.793 41.3826 112.18 39.7695 112.18 37.7826C112.18 35.7958 113.793 34.1826 115.78 34.1826H135.22C137.207 34.1826 138.82 35.7958 138.82 37.7826Z",
    fill: "#2D2E50"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M113.17 85.4221V91.8733C113.17 92.3819 112.757 92.7949 112.248 92.7949H107.416C106.907 92.7949 106.494 92.3819 106.494 91.8733V85.4221C106.494 84.9135 106.907 84.5005 107.416 84.5005H112.248C112.757 84.5005 113.17 84.9135 113.17 85.4221Z",
    fill: "#97D0F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M113.17 85.4221V91.8733C113.17 92.3819 112.757 92.7949 112.248 92.7949H107.416C106.907 92.7949 106.494 92.3819 106.494 91.8733V85.4221C106.494 84.9135 106.907 84.5005 107.416 84.5005H112.248C112.757 84.5005 113.17 84.9135 113.17 85.4221Z",
    stroke: "#4AA6E4",
    strokeWidth: 0.6912
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M123.308 85.4221V91.8733C123.308 92.3819 122.895 92.7949 122.387 92.7949H117.554C117.046 92.7949 116.633 92.3819 116.633 91.8733V85.4221C116.633 84.9135 117.046 84.5005 117.554 84.5005H122.387C122.895 84.5005 123.308 84.9135 123.308 85.4221Z",
    fill: "#97D0F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M123.308 85.4221V91.8733C123.308 92.3819 122.895 92.7949 122.387 92.7949H117.554C117.046 92.7949 116.633 92.3819 116.633 91.8733V85.4221C116.633 84.9135 117.046 84.5005 117.554 84.5005H122.387C122.895 84.5005 123.308 84.9135 123.308 85.4221Z",
    stroke: "#4AA6E4",
    strokeWidth: 0.6912
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M134.369 85.4221V91.8733C134.369 92.3819 133.956 92.7949 133.447 92.7949H128.615C128.106 92.7949 127.693 92.3819 127.693 91.8733V85.4221C127.693 84.9135 128.106 84.5005 128.615 84.5005H133.447C133.956 84.5005 134.369 84.9135 134.369 85.4221Z",
    fill: "#97D0F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M134.369 85.4221V91.8733C134.369 92.3819 133.956 92.7949 133.447 92.7949H128.615C128.106 92.7949 127.693 92.3819 127.693 91.8733V85.4221C127.693 84.9135 128.106 84.5005 128.615 84.5005H133.447C133.956 84.5005 134.369 84.9135 134.369 85.4221Z",
    stroke: "#4AA6E4",
    strokeWidth: 0.6912
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M144.504 85.4221V91.8733C144.504 92.3819 144.091 92.7949 143.582 92.7949H138.75C138.241 92.7949 137.828 92.3819 137.828 91.8733V85.4221C137.828 84.9135 138.241 84.5005 138.75 84.5005H143.582C144.091 84.5005 144.504 84.9135 144.504 85.4221Z",
    fill: "#97D0F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M144.504 85.4221V91.8733C144.504 92.3819 144.091 92.7949 143.582 92.7949H138.75C138.241 92.7949 137.828 92.3819 137.828 91.8733V85.4221C137.828 84.9135 138.241 84.5005 138.75 84.5005H143.582C144.091 84.5005 144.504 84.9135 144.504 85.4221Z",
    stroke: "#4AA6E4",
    strokeWidth: 0.6912
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M120.097 77.5813C120.097 78.0899 119.684 78.5029 119.176 78.5029H107.195C106.686 78.5029 106.273 78.0899 106.273 77.5813C106.273 77.0726 106.686 76.6597 107.195 76.6597H119.176C119.684 76.6597 120.097 77.0726 120.097 77.5813Z",
    fill: "#53AFEB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M131.615 73.8947C131.615 74.5305 131.099 75.0467 130.463 75.0467H107.423C106.788 75.0467 106.271 74.5305 106.271 73.8947C106.271 73.2589 106.788 72.7427 107.423 72.7427H130.463C131.099 72.7427 131.615 73.2589 131.615 73.8947Z",
    fill: "#53AFEB"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_12955_22430",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 47,
    width: 66,
    height: 66
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "__lottie_element_692"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M92.7832 47.7998H157.583V112.6H92.7832V47.7998Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_12955_22430)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M125.184 64.2407C133.991 64.2407 141.143 71.392 141.143 80.1998C141.143 89.0075 133.991 96.1588 125.184 96.1588C116.376 96.1588 109.225 89.0075 109.225 80.1998C109.225 71.392 116.376 64.2407 125.184 64.2407Z",
    fill: "#F48B33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M134.223 67.5017C140.847 72.149 142.632 80.8597 138.208 86.9409C133.783 93.022 124.813 94.1862 118.189 89.5388C111.565 84.8915 109.779 76.1808 114.204 70.0996C118.628 64.0185 127.599 62.8543 134.223 67.5017Z",
    fill: "#F48B33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M125.184 64.2407C133.991 64.2407 141.143 71.392 141.143 80.1998C141.143 89.0075 133.991 96.1588 125.184 96.1588C116.376 96.1588 109.225 89.0075 109.225 80.1998C109.225 71.392 116.376 64.2407 125.184 64.2407Z",
    stroke: "#F48B33",
    strokeWidth: 1.5552
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    opacity: 0.0223957
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M125.184 64.9204C133.617 64.9204 140.463 71.7672 140.463 80.2C140.463 88.6328 133.617 95.4795 125.184 95.4795C116.751 95.4795 109.904 88.6328 109.904 80.2C109.904 71.7672 116.751 64.9204 125.184 64.9204Z",
    fill: "#F48B33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M118.82 81.7193L123.34 85.306L131.971 75.3916",
    stroke: "#F48B33",
    strokeWidth: 1.86624,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M118.82 81.7196L123.34 85.3062C123.34 85.3062 127.436 80.602 129.984 77.6743",
    stroke: "white",
    strokeWidth: 2.44944,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_12955_22430",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: -27,
    width: 120,
    height: 120
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "__lottie_element_682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M107 -27H227V93H107V-27Z",
    fill: "white"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_12955_22430)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M203.702 0.394531C196.802 0.394531 136.602 0.694531 130.302 0.694531C124.002 0.694531 121.602 2.79453 121.602 9.99453C121.602 18.9945 121.752 38.3445 121.752 43.8945C121.752 49.4445 123.402 50.7945 129.852 50.7945C136.302 50.7945 141.814 50.7945 144.514 50.7945C147.214 50.7945 147.664 51.6195 147.552 54.1695C147.442 56.6421 147.327 58.0695 146.952 61.8945C146.496 66.5439 147.246 66.4434 149.502 63.6945C151.902 60.7695 154.527 57.3195 157.602 53.4945C159.669 50.9226 161.202 50.7945 163.602 50.7945C166.002 50.7945 198.902 50.4945 204.602 50.4945C210.302 50.4945 212.102 48.6945 212.102 43.8945C212.102 39.0945 212.402 13.8945 212.402 8.49453C212.402 3.09453 209.702 0.394531 203.702 0.394531Z",
    fill: "#F48B33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M203.702 0.394531C196.802 0.394531 136.602 0.694531 130.302 0.694531C124.002 0.694531 121.602 2.79453 121.602 9.99453C121.602 18.9945 121.752 38.3445 121.752 43.8945C121.752 49.4445 123.402 50.7945 129.852 50.7945C136.302 50.7945 141.814 50.7945 144.514 50.7945C147.214 50.7945 147.664 51.6195 147.552 54.1695C147.442 56.6421 147.327 58.0695 146.952 61.8945C146.496 66.5439 147.499 66.5727 148.977 63.3381C151.452 57.9195 155.525 50.4801 158.652 46.6821C161.627 43.068 165.939 43.3803 181.802 42.2445C202.54 40.7595 203.402 40.2945 208.202 10.2945C209.055 4.96233 209.702 0.394531 203.702 0.394531Z",
    fill: "#FF9940"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M144.881 19.6291V28.8451C144.881 30.5406 143.505 31.9171 141.809 31.9171H136.433C134.738 31.9171 133.361 30.5406 133.361 28.8451V19.6291C133.361 17.9337 134.738 16.5571 136.433 16.5571H141.809C143.505 16.5571 144.881 17.9337 144.881 19.6291Z",
    fill: "#E16A00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M161.2 19.6291V28.8451C161.2 30.5406 159.823 31.9171 158.128 31.9171H152.752C151.056 31.9171 149.68 30.5406 149.68 28.8451V19.6291C149.68 17.9337 151.056 16.5571 152.752 16.5571H158.128C159.823 16.5571 161.2 17.9337 161.2 19.6291Z",
    fill: "#E16A00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M178.161 19.6291V28.8451C178.161 30.5406 176.784 31.9171 175.089 31.9171H169.713C168.017 31.9171 166.641 30.5406 166.641 28.8451V19.6291C166.641 17.9337 168.017 16.5571 169.713 16.5571H175.089C176.784 16.5571 178.161 17.9337 178.161 19.6291Z",
    fill: "#E16A00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M195.153 19.6291V28.8451C195.153 30.5406 193.776 31.9171 192.081 31.9171H186.705C185.009 31.9171 183.633 30.5406 183.633 28.8451V19.6291C183.633 17.9337 185.009 16.5571 186.705 16.5571H192.081C193.776 16.5571 195.153 17.9337 195.153 19.6291Z",
    fill: "#E16A00"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12955_22430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 119,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.65a6787cdcf5760356ace7d4e878299a.svg";
export { ForwardRef as ReactComponent };